/* eslint-disable @next/next/no-img-element */
import React, { useState } from 'react';
import Head from 'next/head';
import { useAmp } from 'next/amp';
import Container from '../../atoms/Container';
import RedButton from '../../atoms/RedButton';
import WhiteButton from '../../atoms/WhiteButton/WhiteButton';
import Styles from './Header.css';
import CleanButton from '../../atoms/CleanButton/CleanButton';
import Menu from '../Menu';
import SidebarContent from './SidebarContent';
import SearchBar from '../SearchBar/SearchBar';
import { isBrowser } from '../../../utils/browser';

function isValidNumber(value) {
  if (value === null || value === undefined || isNaN(value)) return false;
  return true;
}

function Header({ disableMenu, importPrefix, isHome, isHome24, showSearch = true }) {
  const isAmp = useAmp();
  const [menuOpen, setMenuOpen] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);
  const [activeIndex, setActiveIndex] = useState(null);
  const [menuExtraClasses, setMenuExtraClasses] = useState('sidebar-display-hidden');

  const changeMenuState = (open) => {
    if (open) {
      setMenuExtraClasses('sidebar-display-visible');
      setTimeout(() => setMenuOpen(true), 50);
      return;
    }

    setMenuOpen(false);
    setTimeout(() => {
      setMenuExtraClasses('sidebar-display-hidden');
    }, 250);
  };

  const focusSearchInputMobile = () => {
    if (!isBrowser()) return;

    const input = document.getElementById('form-search-mobile');
    if (input) input.focus();
  };

  return (
    <>
      <Head>
        <link
          rel="preload"
          href={`${importPrefix}static/amp/shared/assets/logo_reduced.svg`}
          as="image"
          media="(max-width: 991px)"
        />
        <link
          rel="preload"
          href={`${importPrefix}static/amp/shared/assets/logo_2.svg`}
          as="image"
          media="(min-width: 992px)"
        />
      </Head>
      <header id="santander-header" className={isAmp ? '' : 'regular'}>
        <Container className="wrapper desktop">
          <a href={`${importPrefix}.`} id="logo-santander-header-desktop">
            {isHome ? (
              <>
                {isAmp && (
                  <amp-img
                    src={`${importPrefix}static/amp/shared/assets/logo_2.svg`}
                    alt="aymore financiamento de veículos novos ou usados"
                    layout="fixed"
                    height="20"
                    width="251"
                  />
                )}

                {!isAmp && (
                  <img
                    src={`${importPrefix}static/amp/shared/assets/logo_2.svg`}
                    alt="aymore financiamento de veículos novos ou usados"
                    height="20"
                    width="251"
                  />
                )}
              </>
            ) : (
              <>
                {isAmp && (
                  <amp-img
                    src={`${importPrefix}static/amp/shared/assets/logo_2.svg`}
                    alt="Logo Santander Financiamentos"
                    layout="fixed"
                    height="20"
                    width="251"
                  />
                )}

                {!isAmp && (
                  <img
                    src={`${importPrefix}static/amp/shared/assets/logo_2.svg`}
                    alt="Logo Santander Financiamentos"
                    height="20"
                    width="251"
                  />
                )}
              </>
            )}
          </a>
          {!!showSearch && (
            <SearchBar
              id="search-desktop"
              formId="form-search-desktop"
              importPrefix={importPrefix}
            />
          )}

          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            {/* {isHome24 ? ( */}
            <>
              <RedButton
                href="https://www.santanderfinanciamentos.com.br/spa-mktfinweb/#/login?int_source=portalSF"
                target="_blank"
                rel="noopener"
                id="area-do-cliente-header-desktop"
              >
                Área do Cliente
              </RedButton>
            </>
            {/* ) : (
              <>
                <WhiteButton
                  href="https://www.santanderfinanciamentos.com.br/spa-mktfinweb/#/login?int_source=portalSF"
                  target="_blank"
                  rel="noopener"
                  id="area-do-cliente-header-desktop"
                >
                  Área do Cliente
                </WhiteButton>
                <RedButton
                  href="https://abrasuaconta.santander.com.br/landing/?ori=SF&int_source=pagina-home-header-abra-sua-conta&utm_source=cross-sell-financeira&utm_medium=portal-financeira-outrosprod&utm_campaign=cross-sell-financeira-portal-financeira-outrosprod&cp=94&sp=1"
                  target="_blank"
                  rel="noopener"
                  id="abra-sua-conta-header-desktop"
                >
                  Abra sua conta
                </RedButton>
              </>
            )} */}
          </div>
        </Container>
        {!!showSearch && (
          <SearchBar
            id="search-mobile"
            formId="form-search-mobile"
            importPrefix={importPrefix}
            mobile
            open={searchOpen}
            hidden
            data-amp-bind-hidden="(showMobileSearch == undefined || showMobileSearch == false || showMobileSearch == null || !showMobileSearch || showMobileSearch == '')"
            onClose={() => {
              setSearchOpen(false);
            }}
          />
        )}
        <Container
          className={`wrapper-mb mobile ${!isAmp && searchOpen ? 'hide-header' : ''}`}
          data-amp-bind-hidden="showMobileSearch == true"
        >
          <CleanButton
            on="tap:santander-sidebar.toggle, icon-open-menu.toggleVisibility , icon-close-menu.toggleVisibility"
            data-amp-bind-hidden="showMobileSearch == true"
            style={{
              visibility: disableMenu ? 'hidden' : 'visible',
            }}
            onClick={(ev) => {
              ev.preventDefault();
              changeMenuState(!menuOpen);
            }}
          >
            {isAmp && (
              <amp-img
                id="icon-open-menu"
                src={`${importPrefix}static/amp/shared/assets/ic_menu.svg`}
                alt="Abrir menu"
                layout="fixed"
                height="16"
                width="16"
              />
            )}

            {!isAmp && !menuOpen && (
              <img
                id="icon-open-menu"
                src={`${importPrefix}static/amp/shared/assets/ic_menu.svg`}
                alt="Abrir menu"
                height="22"
                width="22"
              />
            )}

            <span hidden={!menuOpen} id="icon-close-menu">
              {isAmp && (
                <amp-img
                  src={`${importPrefix}static/amp/shared/assets/ic_close.svg`}
                  alt="Fechar menu"
                  layout="fixed"
                  height="16"
                  width="16"
                />
              )}

              {!isAmp && (
                <img
                  src={`${importPrefix}static/amp/shared/assets/ic_close.svg`}
                  alt="Fechar menu"
                  height="18"
                  width="18"
                />
              )}
            </span>
          </CleanButton>

          <a href={`${importPrefix}.`} id="logo-santander-header-mobile">
            {isAmp && (
              <amp-img
                src={`${importPrefix}static/amp/shared/assets/logo_reduced.svg`}
                alt="Logo Santander Financiamentos"
                layout="fixed"
                height="24"
                width="128"
              />
            )}
            {!isAmp && (
              <img
                src={`${importPrefix}static/amp/shared/assets/logo_reduced.svg`}
                alt="Logo Santander Financiamentos"
                height="24"
                width="128"
              />
            )}
          </a>

          <div className="row-header">
            {!!showSearch && (
              <>
                {isAmp && (
                  <amp-img
                    id="icone-lupa-mobile"
                    src={`${importPrefix}static/amp/shared/assets/ic_search_red.svg`}
                    alt="Ícone de lupa"
                    layout="fixed"
                    height="24"
                    width="24"
                    on="tap:AMP.setState({showMobileSearch: true})"
                    role="button"
                    tabIndex="0"
                  />
                )}

                {!isAmp && (
                  <img
                    id="icone-lupa-mobile"
                    src={`${importPrefix}static/amp/shared/assets/ic_search_red.svg`}
                    alt="Ícone de lupa"
                    height="24"
                    width="24"
                    onClick={() => {
                      changeMenuState(false);
                      setSearchOpen(true);
                      focusSearchInputMobile();
                    }}
                  />
                )}
              </>
            )}
            <a
              href="https://www.santanderfinanciamentos.com.br/spa-mktfinweb/#/login?int_source=portalSF"
              target="_blank"
              rel="noopener"
              className="login-mb"
              id="area-do-cliente-header-mobile"
            >
              Área do Cliente
              {isAmp && (
                <amp-img
                  src={`${importPrefix}static/amp/shared/assets/ic_arrow_right_red.svg`}
                  alt="Ícone de usuário"
                  layout="fixed"
                  height="16"
                  width="16"
                />
              )}
              {!isAmp && (
                <img
                  src={`${importPrefix}static/amp/shared/assets/ic_arrow_right_red.svg`}
                  alt="Ícone de usuário"
                  height="16"
                  width="16"
                />
              )}
            </a>
          </div>
        </Container>
      </header>
      <section id="fixed-spacer" />
      <Menu importPrefix={importPrefix} />
      {isAmp && (
        <amp-sidebar id="santander-sidebar" layout="nodisplay">
          <Container className="container-mobile-header">
            <amp-nested-menu layout="fill">
              <SidebarContent importPrefix={importPrefix} />
            </amp-nested-menu>
          </Container>
        </amp-sidebar>
      )}

      {!isAmp && (
        <div
          id="santander-sidebar"
          className={`sidebar-ampless ${menuOpen ? 'opened' : ''} ${menuExtraClasses}`}
          aria-hidden={menuOpen ? 'false' : 'true'}
        >
          <Container className="container-mobile-header" aria-hidden={menuOpen ? 'false' : 'true'}>
            <div className={`nested-menu-ampless ${isValidNumber(activeIndex) ? ' opened' : ''}`}>
              <SidebarContent
                importPrefix={importPrefix}
                onChange={(index) => {
                  setActiveIndex(index);
                }}
              />
            </div>
          </Container>
        </div>
      )}

      <style jsx>{Styles}</style>
    </>
  );
}

Header.defaultProps = {
  importPrefix: '',
};

export default Header;
